import {ImageRequestParams} from "./image-request-params";
import {EntityViewModel} from "../entity/entity.view-model";

export class EntityLogoRequestParams extends ImageRequestParams {
  id: Number;
  pngName: Boolean;
  fallbackResourceId: Number;
  fallbackResourceName: String;

  constructor(params: EntityLogoRequestParams, entity: EntityViewModel) {
    super({...params, version: entity?.imageVersion});

    this.id = entity.id;
    this.pngName = 'default1';
    this.fallbackResourceId = params.fallbackResourceId || this.id;
    this.fallbackResourceName = params.fallbackResourceName || params.resourceName;
    this.ratio = params.ratio;
  }

  get pngNameParam() {
    return this.fallbackResourceId || this.pngName;
  }

  get params(): * {
    return `${super.params},d_${this.fallbackResourceName}${this.isRound ? ':Round' : ''}:${this.pngNameParam}.png`;
  }

  toString(): String {
    return super.toString() + '/' + this.id;
  }

  fallbackUrl(): String {
    this.fallbackResourceId = 'default.png';

    return super.toString();
  }
}
